import { Builder } from "@builder.io/react";
import { BuilderAccordion } from "./BuilderAccordion";
var defaultTitle = {
    "@type": "@builder.io/sdk:Element",
    layerName: "Accordion item title",
    children: [
        {
            "@type": "@builder.io/sdk:Element",
            component: {
                name: "Typography",
                options: {
                    textContent: "I am an accordion title. Click me!",
                    variant: "subheadingSansRegular"
                }
            }
        }
    ]
};
var defaultDetail = {
    "@type": "@builder.io/sdk:Element",
    layerName: "Accordion item detail",
    children: [
        {
            "@type": "@builder.io/sdk:Element",
            component: {
                name: "Typography",
                options: {
                    textContent: "I am an accordion detail, hello!"
                }
            }
        }
    ]
};
export var registerBuilderAccordion = function() {
    Builder.registerComponent(BuilderAccordion, {
        name: "Accordion",
        hideFromInsertMenu: false,
        // to make sure accordion is not wrapped in a div
        noWrap: true,
        canHaveChildren: true,
        inputs: [
            {
                name: "title",
                type: "string",
                defaultValue: "You may be wondering",
                localized: true
            },
            {
                name: "titleAlignment",
                type: "string",
                enum: [
                    "center",
                    "end",
                    "justify",
                    "left",
                    "right",
                    "start",
                    "unset"
                ]
            },
            {
                name: "useComponentsForItems",
                type: "boolean",
                helperText: "Use components as items instead of text fields.",
                advanced: true,
                defaultValue: false,
                onChange: function(options) {
                    if (options.get("useComponentsForItems") === true) {
                        options.set("contents", []);
                    } else {
                        options.set("contentComponents", []);
                    }
                }
            },
            {
                name: "contents",
                type: "list",
                subFields: [
                    {
                        name: "question",
                        type: "string",
                        localized: true
                    },
                    {
                        name: "answer",
                        type: "richText",
                        localized: true
                    }
                ],
                showIf: function(options) {
                    return !options.get("useComponentsForItems");
                }
            },
            {
                name: "contentComponents",
                type: "list",
                broadcast: true,
                subFields: [
                    {
                        name: "question",
                        type: "uiBlocks",
                        defaultValue: [
                            defaultTitle
                        ]
                    },
                    {
                        name: "answer",
                        type: "uiBlocks",
                        defaultValue: [
                            defaultDetail
                        ]
                    }
                ],
                showIf: function(options) {
                    return options.get("useComponentsForItems");
                }
            }
        ]
    });
};
